import { useSelector } from 'react-redux';
import Product from '../product/Product';
import './ProductList.css';
import { selectActiveCategoryFilter, selectActiveCollectionFilter, selectSort } from '../../features/shopPage/shopPageSlice';

export default function ProductList({products, addToCartClick}) {
    const sort = useSelector(selectSort);
    const activeCategoryFilter = useSelector(selectActiveCategoryFilter);
    const activeCollectionFilter = useSelector(selectActiveCollectionFilter);

    const sortedProducts = [...products].sort((a, b) => {
        if (sort.value === 'lowToHigh') {
            return a.price - b.price;
        } else if (sort.value === 'highToLow') {
            return b.price - a.price;
        } else if (sort.value === 'newest') {
            return b.created - a.created;
        } else {
            return 0;
        }
    });

    const categoryProducts = sortedProducts.filter(product => activeCategoryFilter === 'All' || product.category === activeCategoryFilter)
    const collectionProducts = categoryProducts.filter(product => activeCollectionFilter === 'All' || product.collection === activeCollectionFilter);

    return (
        <section className="productList">
            {collectionProducts.map(product => {
                return (
                    <Product 
                        product={product}
                        addToCartClick={addToCartClick}
                    />
                )
            })}
        </section>
    )
}